var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-icon-btn',_vm._g(_vm._b({staticClass:"add-btn",attrs:{"elevation":_vm.isMobile ? 12 : 4,"fab":"","icon":"icon-plus","size":"24"}},'app-icon-btn',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }